import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

export const MainLayoutType = {
  FULL: 'full',
  MEDIUM: 'medium',
  SMALL: 'small'
} as const
export type MainLayoutType = (typeof MainLayoutType)[keyof typeof MainLayoutType]

interface Props extends ChildProps {
  type?: MainLayoutType
  bottomSpace?: boolean
  noNavi?: boolean
  scrollable?: boolean
}

const Main = ({
  children,
  type = MainLayoutType.MEDIUM,
  bottomSpace = false,
  noNavi = false,
  scrollable = false
}: Props) => {
  return (
    <main className={clsx('relative mt-14 min-w-0 items-stretch', !noNavi && 'ml-60')}>
      <div
        className={clsx(
          'bg-primary relative z-1 mx-auto min-h-[calc(100vh-56px)] rounded-tr-4xl px-16',
          bottomSpace && 'pb-12'
        )}
      >
        <div
          className={clsx(
            'mx-auto py-6',
            type == MainLayoutType.FULL
              ? 'w-full'
              : type == MainLayoutType.MEDIUM
                ? 'w-full max-w-[1152px]'
                : type == MainLayoutType.SMALL
                  ? 'w-full max-w-[800px]'
                  : '',
            !scrollable
              ? type == MainLayoutType.MEDIUM
                ? ''
                : type == MainLayoutType.SMALL
                  ? ''
                  : ''
              : 'w-full'
          )}
        >
          {children}
        </div>
      </div>
    </main>
  )
}

export default Main
